/*
The allocation scheme is to use take a hash of the experiment name
combined with the federated ID.  The last 5 digits of the hash are
used as the index into the buckets (modulo the number of buckets).

The allocation is therefore deterministic for a given user and
experiment.
*/

import sha256 from 'hash.js/lib/hash/sha/256';

export const EXPERIMENT_BUCKET_VARIANT = 'variant';
export const EXPERIMENT_BUCKET_CONTROL = 'control';
export const EXPERIMENT_BUCKET_VARIANT_A = 'variantA';
export const EXPERIMENT_BUCKET_VARIANT_B = 'variantB';
export const EXPERIMENT_BUCKET_VARIANT_C = 'variantC';
export const EXPERIMENT_BUCKET_NONE = 'none';

export const defaultBucketAssignment = {
  basic_experiment: [EXPERIMENT_BUCKET_VARIANT, EXPERIMENT_BUCKET_CONTROL],
  curiosity_explr03: [EXPERIMENT_BUCKET_VARIANT, EXPERIMENT_BUCKET_CONTROL]
};

const computeBucketNumber = (str, n) => {
  const hash = sha256()
    .update(str)
    .digest('hex')
    .slice(-5);
  return parseInt(hash, 16) % n;
};

const experimentBucket = (
  experimentName,
  federatedId,
  bucketsOverride = undefined
) => {
  if (!federatedId) {
    return EXPERIMENT_BUCKET_NONE;
  }

  const buckets = bucketsOverride || defaultBucketAssignment[experimentName];

  const index = computeBucketNumber(
    `${experimentName}:${federatedId}`,
    buckets.length
  );
  return buckets[index];
};

export default experimentBucket;
